interface ModalProps {
  open: boolean;
  onClose?: () => void;
  title: string;
  size?: 'md' | 'lg';
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export default function Modal({ open, onClose, title, size = 'md', children, footer }: ModalProps) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <div className={`modal${size === 'lg' ? ' modal--lg' : ''}`}>
        <div className="modal__header">
          <h2 className="modal__title" id="modal-title">{title}</h2>
          {onClose && (
            <button className="modal__close" onClick={onClose} aria-label="Close modal">
              <i className="fa-solid fa-xmark" aria-hidden="true" />
            </button>
          )}
        </div>
        <div className="modal__body">{children}</div>
        {footer && <div className="modal__footer">{footer}</div>}
      </div>
    </div>
  );
}
